export default "__VITE_ASSET__5a82127d__"